module.exports = __webpack_public_path__ + "img/avatar1.dfdb236d.png";